import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api, { mediaUrl } from "@/lib/api";
import { useLang } from "@/context/LangContext";
import barbara from "@/assets/barbara.jpg";

const DEFAULT_ABOUT_IT = `Sono una ragazza semplice, ma ho sempre avuto un modo un po' diverso di guardare le cose. Tendo a osservarle, approfondirle, collegarle e a chiedermi cosa ci sia dietro quello che vedo.

Forse è anche per questo che, nel corso della mia vita, ho imparato a vivere persino i momenti più dolorosi con una consapevolezza e una leggerezza che non sempre, da fuori, sono state facili da comprendere.

Questo spazio nasce da qui. Dal mio modo di pensare, di sentire e di guardare la realtà. Dalle cose che mi fanno riflettere, dalle domande che mi pongo, dalle connessioni che vedo e dai pensieri che sento il bisogno di esprimere.

Non penso che il mio modo di vedere le cose sia necessariamente giusto o sbagliato. È semplicemente il mio. Questo è il mio mondo, senza la necessità di renderlo perfetto, definitivo o uguale a quello degli altri.`;

export default function About() {
  const { lang } = useLang();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const img = settings?.about_image_path ? mediaUrl(settings.about_image_path) : barbara;
  const text = settings?.about_text?.[lang] || settings?.about_text?.it || DEFAULT_ABOUT_IT;
  const paras = text.split("\n\n").filter(Boolean);

  return (
    <div data-testid="about-page" className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 pt-16 sm:pt-24 pb-24">
      <div className="grid lg:grid-cols-[1fr_1.1fr] gap-10 lg:gap-20 items-start">
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }} animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7 }}
          className="lg:sticky lg:top-28"
        >
          <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-[rgba(198,137,158,0.2)]">
            <img src={img} alt="Barbara Uwadie" className="w-full h-full object-cover" data-testid="about-portrait" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
        >
          <div className="eyebrow mb-4">Su di me</div>
          <div className="gold-line mb-7" />
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight leading-[1.02] mb-8">
            Barbara Uwadie
          </h1>
          <div className="prose-unfiltered">
            {paras.map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
